/** @jsxImportSource @emotion/react */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-unused-vars */
import tw from 'twin.macro';
import { css } from '@emotion/react';
import { useRef } from 'react';
import {
  ManageLimitsModal,
  ManageLimitsModalRef,
} from './ManageLimitsModal';
import { ReactComponent as SettingSvg } from 'assets/Icons/setting.svg';

type Props = {};

export const ManageLimitsButton = (props: Props) => {
  const manageLimitsModalRef = useRef<ManageLimitsModalRef>(null);

  const handleClick = async () => {
    await manageLimitsModalRef.current?.show();
  };

  return (
    <>
      <button
        className="button btn-primary large"
        tw="flex items-center (max-width[unset] w-auto px-3.5)!"
        onClick={handleClick}
      >
        <span tw="flex mr-2" css={iconWrapperCss}>
          <SettingSvg />
        </span>
        <span>Manage Limits</span>
      </button>
      <ManageLimitsModal ref={manageLimitsModalRef} />
    </>
  );
};

const iconWrapperCss = css`
  svg {
    fill: #fff;
  }
`;